import { useEffect } from 'react';
import Cookies from 'universal-cookie';

const Logout = (props) => {
    useEffect(() => {
        const cookies = new Cookies();
        cookies.remove("evarsv_aut10", { path: '/' });
        setTimeout(() => props.history.push("/login"), 1000);

        return () => {
            const cookies = new Cookies();
            cookies.remove("evarsv_aut10", { domain: 'evaacademy.azurewebsites.net', path: '/' });
        }
    }, []);

    return null;
}

export default Logout;